"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarItemDto = void 0;
class NavBarItemDto {
    constructor(params) {
        this.title = "";
        this.type = "";
        this.value = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.title = params.title;
        this.type = params.type;
        this.value = params.value;
        this.order = params.order;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
    }
}
exports.NavBarItemDto = NavBarItemDto;
//# sourceMappingURL=NavBarItemDto.js.map